module.exports = __webpack_public_path__ + "static/media/logo-receipt.9f2b5b69.png";